import React from "react";
import { Route } from "react-router-dom";

import {LinksUIProvider} from "../../contexts/LinksUIContext";
import {LinksContainer} from '../../components/containers/LinksContainer';
import {LinkDetailModal} from "../../components/modules/LinkDetailModal";

import {URLs} from "../../../utils/routes";

export function LinksPage({ history }) {
  const linksUIEvents = {
    openLinkDetailDialog: (id) => {
      history.push(`${URLs.SERVICES_LINKS}/${id}`);
    },
    goToCreateLink: (e, prodId) => {
      history.push(`${URLs.SERVICES_LINKS_CREATE}${prodId ? '?prodId='+prodId : ''}`);
    },
  };

  return (
    <LinksUIProvider linksUIEvents={linksUIEvents}>
      <LinksContainer />

      <Route path={`${URLs.SERVICES_LINK_DETAIL}`}>
        {({ history, match }) => match ? (
          <LinkDetailModal
            show={true}
            key={match.params.linkId}
            linkId={match.params.linkId}
            onHide={() => history.goBack()}
          />
        ) : null}
      </Route>
    </LinksUIProvider>
  );
}
